import { useGetIdentity, useTranslate } from '@pankod/refine-core';
import {
  AntdLayout,
  Space,
  Button,
  Icons,
} from '@pankod/refine-antd';
import { Dropdown } from 'antd';
import { Title } from '../title';
import { header } from './styles';
import { UserOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { User } from 'interfaces';
import { ProfileMenu } from 'pages/user';

const { DownOutlined } = Icons;

export const Header: React.FC = () => {
  const t = useTranslate();
  const { data: user } = useGetIdentity<User>();


  const getUserName = useCallback((userData: User) => {
    let name = userData.firstname ?? 'John';
    let lastname = userData.lastname ?? 'Doe';
    name = name.charAt(0).toUpperCase() + name.slice(1);
    lastname = lastname.charAt(0).toUpperCase() + lastname.slice(1);
    return `${name} ${lastname}`;
  }, []);

  const menu = (
    <ProfileMenu />
  );

  return (
    <AntdLayout.Header style={header}>
      <Title />
      <Dropdown overlay={menu} overlayStyle={{ padding: 12 }}>
        <Button type="primary">
          <Space>
            <UserOutlined />
            {user ? getUserName(user) : 'Guest'}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    </AntdLayout.Header>
  );
};
